import * as React from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { validateLocale } from '../helpers/validateLocale';

import MainRouter from './MainRouter';
import i18n from 'components/i18n';

export interface IRouteParams {
    locale: string;
    id?: string;
}

interface IProps {
}

interface IState {
}

export default class LocaleRouter extends React.Component<IProps, IState> {
    private readonly matchingUserLocale: string = 'en';

    constructor(props: IProps) {
        super(props);
        let userLocales: string[] = ['en'];
        if (navigator.languages && navigator.languages.length) {
            userLocales = userLocales.concat(navigator.languages);
        } else {
            userLocales.push(navigator.language);
        }
        this.matchingUserLocale = validateLocale(userLocales);
        i18n.changeLanguage(this.matchingUserLocale);
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    {/* TODO: locale setup step 3: add `${Env.WEB_PATH}:locale(et|lv|lt|ru|en|fr)` as the path */}
                    <Route path={'/'} component={MainRouter} />
                </Switch>
            </BrowserRouter>
        );
    }
}
